import { useDispatch, useSelector } from "react-redux";
import "./plantDetails.scss";

import {
  Checkbox,
  Button,
  RefreshIcon,
  SearchIcon,
  SliderIcon,
} from "@forge/common";
import {
  removeSelectedVM,
  setLoading,
  getShutDownData,
  getResetStatus,
  getPowerOff,
  getPowerOn,
  setRebootStatus,
  setShutDownStatus,
  setRestoreSnapshot,
  setCreateSnapshot,
  setPowerOff,
  setPowerOn,
  setResetStatus,
  setISOListStatus,
  setMountISO,
  setListSnapshot,
  setUnMountISO,
  getDeleteSnapshot,
  setDeleteSnapshot,
  getUnMountISO,
  getRestoreSnapshot,
  getCreateSnapshot,
  setVMData,
} from "../../../store/action";
import { useEffect, useMemo, useState } from "react";
import { AppState } from "../../../../common/store/combinedReducer";
import noVmIcon from "../../../../common/assets/noVmIcon.png";
import { customToast } from "../../../../App";
import config, {
  REQUIRED_PERMISSIONS,
} from "../../../../common/authentication/config";
import { addSelectedID } from "../../../../common/utility/plantDetailUtils";
import {
  ConfirmModal,
  VMAlert,
} from "../../../../common/utility/ConfirmationModal/ConfirmModalScuff";
import { btnResponsive } from "../../academy/common/utils/helper";
import SnapshotModal from "../../../../common/utility/Snapshot/SnapshotModal";
import ISOModal from "../../../../common/utility/ISOModal";
import SectionPanel from "./sectionPanel";
import { ReactComponent as Component3Icon } from "../../../../common/assets/sliderCheck.svg";
import SearchableSelectDropDown from "../../../../common/components/SearchableSelectDropDown";

const PlantDetails = (props: any) => {
  const dispatch = useDispatch();
  // State for filter node modal

  const [showFilterNodeModal, setShowFilterNodeModal] = useState(false);
  const [selectedNodes, setSelectedNodes] = useState<string[]>([]);
  const [activeNodeFilter, setActiveNodeFilter] = useState<string[]>([]);
  const [searchNodeFilter, setSearchNodeFilter] = useState("");

  const [clearAll, setClearAll] = useState(false);
  const [disableShutDown, setShutDown] = useState(true);
  const [disableRestart, setRestart] = useState(true);
  const [disableRestore, setRestoreSnapshotDisable] = useState(true);
  const [disableCreateSnapshot, setCreateSnapshotDisable] = useState(true);
  const [closeConfirmModal, setCloseConfirmModal] = useState(false);
  const [header, setHeader] = useState("");
  const [contentVal, setContent] = useState("");
  const [poweredVm, setPoweredVm] = useState<any>();
  const [orgId, setOrgId] = useState("");
  const [clicked, setClicked] = useState(false);
  const [openVm, setOpenVm] = useState(false);
  const [showIso, setShowIso] = useState(false);
  const [selectedIso, setSelectedIso] = useState<any>(null);
  const [isoSearch, setISOSearch] = useState("");
  const [snapShotShow, setSnapShotShow] = useState(false);
  const [newSnapshotName, setNewSnapshotName] = useState(null);
  const [selectedSnapshot, setSelectedSnapshot] = useState(null);
  // const [selectedSnapDelete, setSelectedSnapDelete] = useState([]);

  const orgData = useSelector((state: AppState) => state.reducer.orgData);
  const loading = useSelector((state: AppState) => state.reducer.loading);

  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });
  const selectedVM = useSelector((state: AppState) => {
    return state.reducer.selectedVM;
  });
  const rebootStatus = useSelector((state: AppState) => {
    return state.reducer.rebootStatus;
  });
  const shutDownStatus = useSelector((state: AppState) => {
    return state.reducer.shutDownStatus;
  });
  const createSnapShotStatus = useSelector((state: AppState) => {
    return state.reducer.createSnapShotStatus;
  });
  const restoreSnapShotStatus = useSelector((state: AppState) => {
    return state.reducer.restoreSnapShotStatus;
  });
  const powerOffStatus = useSelector((state: AppState) => {
    return state.reducer.powerOffStatus;
  });
  const powerOnStatus = useSelector((state: AppState) => {
    return state.reducer.powerOnStatus;
  });
  const resetStatus = useSelector((state: AppState) => {
    return state.reducer.resetStatus;
  });
  const isoListReducer = useSelector((state: AppState) => {
    return state.reducer.isoList;
  });
  const isoListStatus = useSelector((state: AppState) => {
    return state.reducer.isoListStatus;
  });
  const isoMountStatus = useSelector((state: AppState) => {
    return state.reducer.isoMountStatus;
  });
  const isoMountMessage = useSelector((state: AppState) => {
    return state.reducer.isoMountMessage;
  });
  const snapShotList = useSelector((state: AppState) => {
    return state.reducer.snapShotList;
  });
  const snapShotListStatus = useSelector((state: AppState) => {
    return state.reducer.snapShotListStatus;
  });
  const isoUnmountStatus = useSelector((state: AppState) => {
    return state.reducer.isoUnmountStatus;
  });
  const isoUnmountMessage = useSelector((state: AppState) => {
    return state.reducer.isoUnmountMessage;
  });
  const deleteSnapShotStatus = useSelector((state: AppState) => {
    return state.reducer.deleteSnapShotStatus;
  });
  const selectedCluster = useSelector(
    (state: AppState) => state.reducer.selectedCluster,
  );
  const [selectedSnapIndex, setSelectedSnapIndex] = useState(0);
  const [ISOList, setISOLiSt] = useState<any>(isoListReducer);
  const [validName, setValidName] = useState<boolean>(true);
  const [namePresent, setNamePresent] = useState<boolean>(false);
  const [lastSelectedCluster, setLastSelectedCluster] = useState<
    string | undefined
  >(undefined);

  const filteredClusterDetails = useMemo<Record<string, any[]>>(() => {
    const result: Record<string, any[]> = {};
    if (!orgData) return result;
    const sortClusters = (clusters: any[]) =>
      [...clusters].sort((a: any, b: any) => {
        const an = a.clusterName ?? "";
        const bn = b.clusterName ?? "";
        if (an === config.CLUSTER_DEFAULT) return 1;
        if (bn === config.CLUSTER_DEFAULT) return -1;
        return an.localeCompare(bn, undefined, {
          sensitivity: "base",
        });
      });
    orgData.forEach((plant: any) => {
      if (!plant) return;
      if (activeNodeFilter.length === 0) {
        result[plant.siteId] = sortClusters(plant.clusterDetails ?? []);
      } else {
        result[plant.siteId] = sortClusters(
          (plant.clusterDetails || []).map((cluster: any) => ({
            ...cluster,
            vmDetails: (cluster.vmDetails || []).filter((vm: any) => {
              const nodeType = vm.vmMetadata?.find(
                (meta: any) => meta.key === "Node Type",
              )?.value;
              return activeNodeFilter.includes(nodeType);
            }),
          })),
        );
      }
    });
    return result;
  }, [orgData, activeNodeFilter]);

  useEffect(() => {
    const handleOptionClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const li = target.closest("li");
      if (!li) return;
      const text = li.textContent?.trim();
      if (text && selectedCluster?.includes(text)) {
        //setLastSelectedCluster(text);
        setTimeout(() => {
          document
            .getElementById(`cluster-${text}`)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    };
    document.addEventListener("click", handleOptionClick, true);
    return () => document.removeEventListener("click", handleOptionClick, true);
  }, [selectedCluster, lastSelectedCluster]);

  const escFunction = (event: any) => {
    if (event.key === "Escape") {
      setCloseConfirmModal(false);
      handleClearAll();
      powerActionCancelled();
    }
  };

  const getUniqueNodeTypes = (vmDetails: any[]) => {
    if (!vmDetails || vmDetails.length === 0) return [];

    const nodeTypes = vmDetails
      .map((vm: any) => {
        // Extract node type from vmMetadata
        return vm.vmMetadata?.find((meta: any) => meta.key === "Node Type")
          ?.value;
      })
      .filter((nodeType: string | undefined) => nodeType) // Remove undefined/empty
      .filter((value, index, self) => self.indexOf(value) === index); // Get unique only

    return nodeTypes;
  };

  useEffect(() => {
    document.addEventListener(
      "keydown",
      (event) => {
        if (showFilterNodeModal && event.key === "Escape") {
          setShowFilterNodeModal(false);
          setSearchNodeFilter("");
        }
        escFunction(event);
      },
      false,
    );

    return () => {
      dispatch(setListSnapshot({ status: 0, data: [] }));
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [showFilterNodeModal]);

  useEffect(() => {
    setSelectedNodes([]);
    setActiveNodeFilter([]);
    setShowFilterNodeModal(false);
    setSearchNodeFilter("");
  }, [props.nodeFilterResetKey]);

  useEffect(() => {
    if (isoListStatus === 200) {
      dispatch(setLoading(false));
      setShowIso(true);
      setISOLiSt(isoListReducer);
      setISOListStatus(0);
      dispatch(setISOListStatus(0));
    } else if (isoListStatus !== 200 && isoListStatus !== 0) {
      customToast("Unable to fetch ISO list", "critical");
      dispatch(setLoading(false));
    }
  }, [isoListReducer, isoListStatus]);

  useEffect(() => {
    if (isoMountStatus === 409) {
      dispatch(setLoading(false));
      customToast(isoMountMessage, "critical");
      dispatch(setMountISO({ status: 0, data: "" }));
      dispatch(removeSelectedVM());
    } else if (
      isoMountStatus === 200 ||
      isoMountStatus === 201 ||
      isoMountStatus === 204
    ) {
      const updatedOrgData = orgData.map((plant: any) => ({
        ...plant,
        vmDetails: plant.vmDetails?.map((vm: any) => {
          if (selectedVM?.some((selectedVm: any) => selectedVm.id === vm.id)) {
            return { ...vm, intermediateStatus: "Inserting Media..." };
          }

          return vm;
        }),
      }));
      dispatch(setVMData(updatedOrgData));
      dispatch(setLoading(false));
      dispatch(removeSelectedVM());
    }
  }, [isoMountStatus, isoMountMessage]);

  useEffect(() => {
    if (snapShotListStatus === 200) {
      dispatch(setLoading(false));
      if (snapShotList?.length === 3 && header === "Create Snapshot") {
        setCloseConfirmModal(true);
      } else setSnapShotShow(true);
      setSelectedSnapIndex(0);
    } else {
      dispatch(setLoading(false));
      // dispatch(setListSnapshot({ status: 0, data: [] }));
    }
  }, [snapShotList, snapShotListStatus]);

  useEffect(() => {
    if (isoUnmountStatus === 409) {
      dispatch(setLoading(false));
      customToast(isoUnmountMessage, "critical");
      dispatch(setUnMountISO({ status: 0, data: "" }));
      dispatch(removeSelectedVM());
    } else {
      dispatch(setLoading(false));
      dispatch(removeSelectedVM());
    }
  }, [isoUnmountStatus, isoUnmountMessage]);

  const handleClearAll = () => {
    setClearAll(true);
    setShutDown(true);
    setRestart(true);
    setCreateSnapshotDisable(true);
    setRestoreSnapshotDisable(true);
    setSelectedSnapIndex(0);
    setSelectedSnapshot(null);
    setNewSnapshotName(null);
    setSelectedIso(null);
    setValidName(true);
    setNamePresent(false);
    orgData?.forEach((plant: any) => {
      plant.vmDetails?.forEach((element: any) => {
        element.checked = false;
      });
    });
    dispatch(setLoading(false));
    dispatch(removeSelectedVM());
  };
  // const addSelectedID = () => {
  //   const vmId: any = [];
  //   _.forEach(selectedVM, (data: any) => {
  //     data && vmId.push(data?.id);
  //   });
  //   return vmId;
  // };

  const powerActionCancelled = () => {
    if (!orgData || !poweredVm?.id) return;

    orgData.forEach((plant: any) => {
      plant.vmDetails?.forEach((element: any) => {
        if (element.id !== poweredVm.id) return;

        switch (element.status) {
          case "POWERED_ON":
            if (powerOffStatus === 0) {
              element.isOn = true;
              element.isIntermediate = false;
            }
            break;
          case "POWERED_OFF":
            if (powerOnStatus === 0) {
              element.isOn = false;
              element.isIntermediate = false;
            }
            break;
          case "SUSPENDED":
            element.isOn = false;
            element.isIntermediate = false;
            break;
          default:
            break;
        }
      });
    });
  };

  const handleUnmountClick = (siteId: string) => {
    const updatedOrgData = orgData.map((plant: any) => ({
      ...plant,
      vmDetails: plant.vmDetails?.map((vm: any) => {
        if (selectedVM?.some((selectedVm: any) => selectedVm.id === vm.id)) {
          return { ...vm, intermediateStatus: "Ejecting Media..." };
        }
        return vm;
      }),
    }));
    dispatch(setVMData(updatedOrgData));
    dispatch(
      getUnMountISO({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
  };

  const handlePowerOnClick = (siteId: string) => {
    dispatch(
      getPowerOn({
        vmId: poweredVm.id,
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
  };

  const handlePowerOffClick = (siteId: string) => {
    dispatch(
      getPowerOff({
        vmId: poweredVm.id,
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
  };

  const handleResetClick = (siteId: string) => {
    dispatch(
      getResetStatus({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
  };

  const handleShutDownClick = (siteId: string) => {
    dispatch(
      getShutDownData({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
  };

  // const handleRestartClick = () => {
  //   const vm = addSelectedID();
  //   dispatch(setLoading(true));
  //   if (_.every(selectedVM, ["status", "POWERED_ON"]) === true) {
  //     dispatch(
  //       getRebootData({
  //         vmId: vm,
  //         authorization: localStorage.getItem("access_token"),
  //         siteId: orgData?.siteId,
  //         orgId: orgId,
  //       })
  //     );
  //   } else if (_.every(selectedVM, ["status", "POWERED_OFF"]) === true) {
  //     dispatch(
  //       getStartData({
  //         vmId: vm,
  //         authorization: localStorage.getItem("access_token"),
  //         siteId: orgData?.siteId,
  //         orgId: orgId,
  //       })
  //     );
  //   } else {
  //     if (_.some(selectedVM, ["status", "POWERED_ON"]) === true) {
  //       const vmOff = getVmId("POWERED_ON");
  //       dispatch(
  //         getRebootData({
  //           vmId: vmOff,
  //           authorization: localStorage.getItem("access_token"),
  //           siteId: orgData?.siteId,
  //           orgId: orgId,
  //         })
  //       );
  //     }
  //     if (_.some(selectedVM, ["status", "POWERED_OFF"]) === true) {
  //       const vmOff = getVmId("POWERED_OFF");
  //       dispatch(
  //         getStartData({
  //           vmId: vmOff,
  //           authorization: localStorage.getItem("access_token"),
  //           siteId: orgData?.siteId,
  //           orgId: orgId,
  //         })
  //       );
  //     }
  //   }
  // };
  const deleteSnapShot = (siteId: string) => {
    dispatch(
      getDeleteSnapshot({
        snapshotId: selectedSnapshot,
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
    setSelectedSnapIndex(0);
    setSelectedSnapshot(null);
  };

  const restoreSnapShot = (siteId: string) => {
    dispatch(
      getRestoreSnapshot({
        snapshotId: selectedSnapshot,
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
      }),
    );
    setSelectedSnapIndex(0);
    setSelectedSnapshot(null);
  };

  const createSnapShot = (siteId: string) => {
    dispatch(
      getCreateSnapshot({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: siteId,
        orgId: orgId,
        snapshotName: newSnapshotName,
      }),
    );
    setNewSnapshotName(null);
    setSelectedSnapshot(null);
  };

  useEffect(() => {
    setClearAll(true);
    setShutDown(true);
    setRestart(true);
    setCreateSnapshotDisable(true);
    setRestoreSnapshotDisable(true);
    if (orgData && orgData.length > 0) {
      const val = orgData[0]?.id?.split(":");
      val && val.length > 0 && setOrgId(val[val?.length - 1]);
    }
  }, [orgData]);

  useEffect(() => {
    const handleStatus = (
      status: number,
      expectedStatuses: number[],
      clearAction: () => void,
      resetAction: () => any,
    ) => {
      if (expectedStatuses.includes(status)) {
        dispatch(setLoading(false));
        clearAction();
        dispatch(resetAction());
      }
    };

    handleStatus(shutDownStatus, [200, 201, 204], handleClearAll, () =>
      setShutDownStatus(0),
    );
    handleStatus(rebootStatus, [200, 201, 204], handleClearAll, () =>
      setRebootStatus(0),
    );
    handleStatus(restoreSnapShotStatus, [200, 201, 204], handleClearAll, () =>
      setRestoreSnapshot(0),
    );
    handleStatus(createSnapShotStatus, [200, 201, 204], handleClearAll, () =>
      setCreateSnapshot(0),
    );
    handleStatus(powerOffStatus, [200, 201, 204], handleClearAll, () =>
      setPowerOff(0),
    );
    handleStatus(powerOnStatus, [200, 201, 204], handleClearAll, () =>
      setPowerOn(0),
    );
    handleStatus(resetStatus, [200, 201, 204], handleClearAll, () =>
      setResetStatus(0),
    );
    handleStatus(deleteSnapShotStatus, [200, 201, 204], handleClearAll, () =>
      setDeleteSnapshot(0),
    );

    if (orgDataStatus !== 0) {
      dispatch(setLoading(false));
    }
  }, [
    orgDataStatus,
    shutDownStatus,
    rebootStatus,
    restoreSnapShotStatus,
    createSnapShotStatus,
    powerOffStatus,
    powerOnStatus,
    resetStatus,
    deleteSnapShotStatus,
  ]);

  // Handle case when orgData is null/empty due to API errors (but not when loading)
  if ((!orgData || orgData.length === 0) && !loading) {
    return (
      <div className="multi-plant-wrapper">
        <div className="plant-section">
          <div className="no-data-available">
            <img className="icon-restore" src={noVmIcon} />
            {parseInt(localStorage.getItem("index") || "0") === -1 ? (
              <>
                <span className="no-detail-text">
                  THERE IS NO AVAILABLE DATA FOR THIS SITE
                </span>
                <span className="no-detail-text">
                  Try selecting a different site
                </span>
              </>
            ) : (
              <>
                <span className="no-detail-text">
                  THIS SITE HAS NO AVAILABLE VIRTUAL MACHINE(S) FOR YOU
                </span>
                <span className="no-detail-text">
                  Try selecting a different site
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="multi-plant-wrapper">
      {orgData.map((plant: any) => {
        const hasPermission =
          REQUIRED_PERMISSIONS.VIEW_CUSTOMER_PRIME_SPACE.every((p: string) =>
            plant?.permissions?.includes(p),
          );
        if (!hasPermission) {
          return (
            <div key={plant.siteId} className="plant-section">
              {/* <h3 className="plant-title">{plant.name}</h3> */}
              <div className="no-data-available">
                <img className="icon-restore" src={noVmIcon} />
                {parseInt(localStorage.getItem("index") || "0") === -1 ? (
                  <>
                    <span className="no-detail-text">
                      THERE IS NO AVAILABLE DATA FOR THIS SITE
                    </span>
                    <span className="no-detail-text">
                      Try selecting a different site
                    </span>
                  </>
                ) : (
                  <>
                    <span className="no-detail-text">
                      THIS SITE HAS NO AVAILABLE VIRTUAL MACHINE(S) FOR YOU
                    </span>
                    <span className="no-detail-text">
                      Try selecting a different site
                    </span>
                  </>
                )}
              </div>
            </div>
          );
        }

        if (selectedCluster?.length === 0 && orgDataStatus !== 0) {
          return (
            <div key={plant.siteId} className="plant-section">
              {/* <h3 className="plant-title">{plant.name}</h3> */}
              <div className="no-data-available">
                <img className="icon-restore" src={noVmIcon} />
                <span className="no-detail-text">
                  THIS SITE HAS NO AVAILABLE VIRTUAL MACHINE(S) FOR YOU
                </span>
                <span className="no-detail-text">
                  Try selecting atleast one cluster
                </span>
              </div>
            </div>
          );
        }

        // If no VMs available, show full-screen no-data message
        // if (!plant.vmDetails || plant.vmDetails.length === 0) {
        //   return (
        //     <div key={plant.siteId} className="plant-section">
        //       <div className="no-data-available">
        //         <img className="icon-restore" src={noVmIcon} />
        //         <span className="no-detail-text">
        //           THIS SITE HAS NO AVAILABLE VIRTUAL MACHINE(S) FOR YOU
        //         </span>
        //         <span className="no-detail-text">
        //           Try selecting a different site
        //         </span>
        //       </div>
        //     </div>
        //   );
        // }

        return (
          <div key={plant.siteId} className="plant-section">
            {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
              (p: string) => plant?.permissions?.includes(p),
            ) && (
              <div className="vm-actions-header">
                <div className="vm-actions-left">
                  {!props.isHonAcaTenant && (
                    <span className="cluster-text-nowrap">
                      {selectedCluster?.length > 0
                        ? `${selectedCluster?.length} cluster(s) selected, let's go to`
                        : "No cluster selected"}
                    </span>
                  )}
                  {!props.isHonAcaTenant && selectedCluster?.length > 0 && (
                    <SearchableSelectDropDown
                      key={`filter-cluster-${selectedCluster?.join("-")}`}
                      searchable={false}
                      data={[...selectedCluster]
                        .sort((a: string, b: string) => {
                          if (a === config.CLUSTER_DEFAULT) return 1;
                          if (b === config.CLUSTER_DEFAULT) return -1;
                          return a.localeCompare(b, undefined, {
                            sensitivity: "base",
                          });
                        })
                        .map((c: string) => ({
                          value: c,
                          text: c,
                        }))}
                      selectedIndex={0}
                      disabled={selectedCluster?.length <= 1}
                      searchTerm=""
                      placeholder="Filter Cluster"
                      ariaLabel="Filter Cluster"
                      id="filter-cluster-wrapper"
                      testId="filter-cluster-wrapper-test"
                      className="manage-plant-select"
                      controlClassName="manage-plant-control vm-filter-cluster-control"
                      onChange={(text: string) => {
                        setLastSelectedCluster(text);
                      }}
                    />
                  )}
                </div>
                <div className="vm-actions-right">
                  {/* <Button
                    aria-label="Filter and Sort"
                    className="filter-button font-normal rounded text-white"
                    data-testid="filter-sort-button-left-container"
                    onClick={() => { }}
                    size="regular"
                    icon={<SliderIcon className={`${btnResponsive("text-sm")}`} />}
                    iconPosition="left"
                    variant="tertiary"
                    title="Filter and Sort"
                  >Filter by Sort</Button> */}

                  <div className="filter-node-wrapper">
                    <Button
                      aria-label="Filter by node"
                      className="filter-node-button"
                      onClick={() => {
                        setSelectedNodes(activeNodeFilter);
                        setShowFilterNodeModal(true);
                      }}
                      size="regular"
                      variant="tertiary"
                      icon={
                        activeNodeFilter.length > 0 ? (
                          <Component3Icon />
                        ) : (
                          <SliderIcon />
                        )
                      }
                      iconPosition="left"
                    >
                      Filter by node
                    </Button>

                    {showFilterNodeModal && (
                      <div
                        className="filter-node-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Filter by node"
                      >
                        <h3 className="filter-node-title">Filter</h3>
                        <button
                          className="filter-node-close-btn"
                          aria-label="Close"
                          onClick={() => {
                            setShowFilterNodeModal(false);
                            setSearchNodeFilter("");
                          }}
                        >
                          ×
                        </button>
                        <div className="filter-node-header-row">
                          <span className="filter-node-filter-label">
                            Filter by
                          </span>
                          <button
                            className="filter-node-clear-btn"
                            onClick={() => {
                              setSelectedNodes([]);
                              setSearchNodeFilter("");
                            }}
                            aria-label="Clear all filters"
                          >
                            <RefreshIcon className="filter-node-refresh-icon" />
                            Clear all
                          </button>
                        </div>
                        <div className="filter-node-search-wrapper">
                          <SearchIcon className="filter-node-search-icon" />
                          <input
                            className="filter-node-search-input"
                            placeholder="Search"
                            aria-label="Search nodes"
                            value={searchNodeFilter}
                            onChange={(e) =>
                              setSearchNodeFilter(e.target.value)
                            }
                          />
                        </div>
                        <div className="filter-node-list">
                          {(() => {
                            const filteredNodes = getUniqueNodeTypes(
                              plant?.clusterDetails?.flatMap(
                                (cluster: any) => cluster.vmDetails || [],
                              ),
                            ).filter((node: string) =>
                              node
                                .toLowerCase()
                                .includes(searchNodeFilter.toLowerCase()),
                            );
                            if (filteredNodes.length === 0) {
                              return (
                                <div className="filter-node-no-data">
                                  No Data Found
                                </div>
                              );
                            }
                            return filteredNodes.map((node: string) => {
                              const checked = selectedNodes.includes(node);
                              return (
                                <div key={node} className="filter-node-item">
                                  <Checkbox
                                    id={`node-checkbox-${node}`}
                                    checked={checked}
                                    onChange={() => {
                                      setSelectedNodes(
                                        checked
                                          ? selectedNodes.filter(
                                              (n) => n !== node,
                                            )
                                          : [...selectedNodes, node],
                                      );
                                    }}
                                    className="filter-node-checkbox"
                                  />

                                  <label
                                    htmlFor={`node-checkbox-${node}`}
                                    className={`filter-node-label${checked ? " filter-node-label--checked" : ""}`}
                                  >
                                    {node}
                                  </label>
                                </div>
                              );
                            });
                          })()}
                        </div>
                        <div className="filter-node-footer">
                          <button
                            className="filter-node-cancel-btn"
                            onClick={() => {
                              setShowFilterNodeModal(false);
                              setSearchNodeFilter("");
                            }}
                            aria-label="Cancel"
                          >
                            Cancel
                          </button>
                          <button
                            className="filter-node-submit-btn"
                            onClick={() => {
                              setActiveNodeFilter(selectedNodes);
                              setShowFilterNodeModal(false);
                              setSearchNodeFilter("");
                              handleClearAll();
                            }}
                            // disabled={selectedNodes.length === 0}
                            aria-label="Show Results"
                          >
                            Show Results
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <Button
                    aria-label="Clear selection"
                    className="clear-selection-button"
                    data-testid="clear-selection-button-left-container"
                    onClick={() => handleClearAll()}
                    disabled={
                      disableCreateSnapshot &&
                      disableRestore &&
                      disableRestart &&
                      disableShutDown
                    }
                    size="regular"
                    variant="tertiary"
                  >
                    Clear Selection
                  </Button>

                  <Button
                    aria-label="Restart"
                    data-testid="restart-button-left-container"
                    onClick={() => {
                      if (plant.IsVCDAlive === false) {
                        customToast(
                          "This site is not available currently, please try after sometime.",
                          "critical",
                        );
                        handleClearAll();
                      } else {
                        setCloseConfirmModal(true);
                        setHeader("Reset");
                        setContent("reset");
                      }
                    }}
                    disabled={disableRestart}
                    size="regular"
                    variant="tertiary"
                    title="Reset"
                    className={`filter-button font-normal rounded text-white vm-reset-button-text ${!disableRestart ? "vm-action-button-active" : ""}`}
                  >
                    Reset
                  </Button>

                  <Button
                    aria-label="Power Off"
                    data-testid="power-off-button-left-container"
                    onClick={() => {
                      if (plant.IsVCDAlive === false) {
                        customToast(
                          "This site is not available currently, please try after sometime.",
                          "critical",
                        );
                        handleClearAll();
                      } else {
                        setCloseConfirmModal(true);
                        setHeader("Shutdown");
                        setContent("shutdown");
                      }
                    }}
                    disabled={disableShutDown}
                    // icon={
                    //   <img
                    //     src={`${process.env.PUBLIC_URL}/power-dashboard-button.svg`}
                    //     alt="Power Off"
                    //     className={`${btnResponsive("text-sm")}`}
                    //   />
                    // }
                    // iconPosition="left"
                    size="regular"
                    variant="tertiary"
                    title="Shut Down"
                    className={`filter-button font-normal rounded text-white vm-reset-button-text ${!disableShutDown ? "vm-action-button-active" : ""}`}
                  >
                    Shut Down
                  </Button>
                </div>
              </div>
            )}

            {/* <div className="button-group">
              <div className="button1-group">
                <Button
                  type="primary"
                  disabled={state.disableRestart}
                  className={state.disableRestart ? "button1-disabled" : "button1-active"}
                  iconRoot="global"
                  icon="redo"
                  content="Reset"
                  iconPosition="left"
                  size="small"
                  onClick={() => {
                    if (plant.IsVCDAlive === false) {
                      customToast("This site is not available currently, please try after sometime.", "critical");
                      handleClearAll(plant.siteId, plant);
                    } else {
                      updatePlantState(plant.siteId, { closeConfirmModal: true, header: "Reset", contentVal: "reset" });
                    }
                  }}
                />
                <Button
                  type="primary"
                  disabled={state.disableShutDown}
                  className={state.disableShutDown ? "button1-disabled" : "button1-active"}
                  icon="power"
                  content="Shutdown"
                  iconPosition="left"
                  size="small"
                  onClick={() => {
                    if (plant.IsVCDAlive === false) {
                      customToast("This site is not available currently, please try after sometime.", "critical");
                      handleClearAll(plant.siteId, plant);
                    } else {
                      updatePlantState(plant.siteId, { closeConfirmModal: true, header: "Shutdown", contentVal: "shutdown" });
                    }
                  }}
                />
              </div>
              <Button
                type="link"
                className={
                  state.disableCreateSnapshot && state.disableRestore && state.disableRestart && state.disableShutDown
                    ? "button-clear button-clear-disable"
                    : "button-clear"
                }
                disabled={
                  state.disableCreateSnapshot && state.disableRestore && state.disableRestart && state.disableShutDown
                }
                content="Clear All"
                onClick={() => handleClearAll(plant.siteId, plant)}
              />
            </div> */}
            <div className="detail-outer-wrapper">
              <SectionPanel
                plantName={plant?.siteId}
                orgId={orgId}
                orgData={orgData}
                plant={plant}
                activeNodeFilter={activeNodeFilter}
                vmDetails={
                  plant ? (filteredClusterDetails[plant.siteId] ?? []) : []
                }
                clearAll={clearAll}
                setClearAll={setClearAll}
                handleClearAll={handleClearAll}
                disabled={disableRestart}
                setRestart={setRestart}
                shutDownClicked={disableShutDown}
                setShutDown={setShutDown}
                setCreateSnapshotDisable={setCreateSnapshotDisable}
                setHeader={setHeader}
                setContent={setContent}
                setCloseConfirmModal={setCloseConfirmModal}
                setPoweredVm={setPoweredVm}
                setClicked={setClicked}
                clicked={clicked}
                setOpenVm={setOpenVm}
                openVm={openVm}
                showIso={showIso}
                setShowIso={setShowIso}
                selectedIso={selectedIso}
                setSnapShotShow={setSnapShotShow}
                isHonAcaTenant={props.isHonAcaTenant}
              />
            </div>

            <ConfirmModal
              setCloseConfirmModal={setCloseConfirmModal}
              handleClearAll={handleClearAll}
              powerActionCancelled={powerActionCancelled}
              header={header}
              snapShotList={snapShotList}
              selectedVM={selectedVM}
              poweredVm={poweredVm}
              closeConfirmModal={closeConfirmModal}
              contentVal={contentVal}
              restoreSnapShot={() => restoreSnapShot(plant.siteId)}
              createSnapShot={() => createSnapShot(plant.siteId)}
              deleteSnapShot={() => deleteSnapShot(plant.siteId)}
              handleShutDownClick={() => handleShutDownClick(plant.siteId)}
              handlePowerOnClick={() => handlePowerOnClick(plant.siteId)}
              handlePowerOffClick={() => handlePowerOffClick(plant.siteId)}
              handleResetClick={() => handleResetClick(plant.siteId)}
              handleUnmountClick={() => handleUnmountClick(plant.siteId)}
            />

            <VMAlert
              setClicked={setClicked}
              setOpenVm={setOpenVm}
              openVm={openVm}
              clicked={clicked}
              orgData={plant}
            />

            <SnapshotModal
              snapShotShow={snapShotShow}
              setSnapShotShow={(val: boolean) => {
                setSnapShotShow(val);
                if (!val) {
                  dispatch(setListSnapshot({ status: 0, data: [] }));
                }
              }}
              setCloseConfirmModal={setCloseConfirmModal}
              header={header}
              snapShotList={snapShotList || []}
              selectedSnapshot={selectedSnapshot}
              setSelectedSnapshot={setSelectedSnapshot}
              selectedSnapIndex={selectedSnapIndex || 0}
              setSelectedSnapIndex={setSelectedSnapIndex}
              newSnapshotName={newSnapshotName || ""}
              setNewSnapshotName={setNewSnapshotName}
              setValidName={setValidName}
              setNamePresent={setNamePresent}
            />

            <ISOModal
              showIso={showIso}
              setShowIso={setShowIso}
              isoSearch={isoSearch}
              setISOSearch={setISOSearch}
              ISOList={ISOList}
              setISOLiSt={setISOLiSt}
              isoListReducer={isoListReducer}
              selectedIso={selectedIso}
              setSelectedIso={setSelectedIso}
              selectedVM={selectedVM}
              addSelectedID={addSelectedID}
              orgData={plant}
              orgId={orgId}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PlantDetails;
